<template>
  <b-modal
    ref="modal"
    title="Preview file"
    size="lg"
    @hide="closeHandler"
    @show="onShowHandler"
  >
    <template #modal-footer>
      <ButtonOutline
        variant="outline-primary"
        @click="$refs.modal.hide()"
      >
        Cancel
      </ButtonOutline>
    </template>

    <b-spinner v-if="isLoading" />

    <b-row v-else-if="items[currentItemId]">
      <b-col cols="10">
        <div v-if="items.length > 1">
          <b-link
            class="c-preview-file__nav--link"
            :disabled="currentItemId === 0"
            @click="currentItemId--"
          >
            Prev
          </b-link>
          <span>|</span>
          <b-link
            class="c-preview-file__nav--link"
            :disabled="currentItemId === items.length - 1"
            @click="currentItemId++"
          >
            Next
          </b-link>
        </div>
        <b-table
          table-class="c-preview-file__table"
          stacked
          bordered
          :items="[items[currentItemId]]"
          :fields="fields"
        />
        <b-link>
          <i class="cil-crop" />
        </b-link>
      </b-col>
      <b-col cols="2">
        <div class="c-preview-file__preview">
          <img
            class="c-preview-file__preview--image"
            :src="items[currentItemId].thumbnail"
            :alt="items[currentItemId].name"
          >
        </div>
        <div 
          v-if="items[currentItemId].alt_url"
          class="c-preview-file__preview mt-2"
        >
          <img
            class="c-preview-file__preview--image"
            :src="items[currentItemId].alt_url"
          >
        </div>
      </b-col>
    </b-row>

    <b-alert
      v-else
      variant="danger"
    >
      No item.
    </b-alert>
  </b-modal>
</template>

<script>
import ButtonOutline from "../../../common/atoms/ButtonOutline.vue";
import mixinModal from './mixin';
import Requests from "../../../../services/api/file-browser";
import { createNamespacedHelpers } from 'vuex'

const { mapGetters } = createNamespacedHelpers('fileBrowser')

export default {
  name: "PreviewFileModal",
  components: {ButtonOutline},
  mixins: [
    mixinModal
  ],
  data: () => ({
    isLoading: false,
    items: [],
    fields: [
      { label: 'Product Name', key: 'product_name' },
      { label: 'Brand', key: 'brand' },
      { label: 'Sub brand', key: 'sub_brand' },
      { label: 'Category', key: '' },
      { label: 'Tags', key: '' },
      { label: 'Primary Image Filename', key: 'name' },
      { label: 'Image Start Date', key: 'image_start_date' },
      { label: 'Image End Date', key: 'image_end_date' },
      { label: 'Graphic Version Number', key: 'graphic_version_number' },
      { label: 'Sector', key: 'sector' },
      { label: 'File Name', key: 'file_name' },
      { label: 'Alternative Image Filename', key: 'alt_filename' },
      { label: 'ASIN', key: 'asin' },
      { label: 'UPC', key: 'upc' },
      { label: 'GTIN', key: '' },
      { label: 'TCIN', key: 'tcin' },
      { label: 'Width', key: 'width' },
      { label: 'Height', key: 'height' },
      { label: 'Depth', key: 'depth' },
      { label: 'Net content', key: 'net_content' },
      { label: 'Net content (numeric)', key: 'net_conntent_numeric' },
      { label: 'Net content statement', key: 'net_content_statement' },
      { label: 'Variants', key: 'variants' },
      { label: 'Product measurements', key: 'product_measurements' },
      { label: 'Product count', key: 'product_count' },
    ],
    currentItemId: 0,
  }),
  computed: {
    ...mapGetters(['selectedItems'])
  },
  methods: {
    async onShowHandler() {
      this.isLoading = true
      try {
        const { data } = await Requests.previewRequest(this.selectedItems.map(({ id }) => id))
        this.items = data.files;
        this.currentItemId = 0;
      } catch (error) {
        this.close();
        toastr.error('Something went wrong while fetching file details')
      } finally {
        this.isLoading = false;
      }
    }
  }
}
</script>

<style scoped lang="scss">
  ::v-deep .c-preview-file__nav--link.disabled {
    color: gray;
    text-decoration: unset;
    cursor: default;
  }
  .c-preview-file__preview {
    border: solid 1px black;
    width: 82px;
    height: 82px;
    display: flex;
    justify-content: center;
    align-items: center;

    &--image {
      max-width: 80px;
      max-height: 80px;
      height: auto;
    }
  }
  ::v-deep .c-preview-file__table td {
    padding: 0.25rem;

    div {
      overflow-wrap: anywhere;
    }
  }
</style>